import { render, staticRenderFns } from "./CalculationAggregationWindow.vue?vue&type=template&id=ff7473e0&"
import script from "./CalculationAggregationWindow.vue?vue&type=script&lang=ts&"
export * from "./CalculationAggregationWindow.vue?vue&type=script&lang=ts&"
import style0 from "./CalculationAggregationWindow.vue?vue&type=style&index=0&id=ff7473e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports